var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "cyber-fitness-component" } }, [
    _c(
      "div",
      { staticClass: "component cyber-fitness-overview" },
      [
        _c("page-header", {
          attrs: {
            title: "Cyber Fitness Overview",
            links: _vm.breadcrumbsLinks,
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card full-width flex-row exercises-section" },
          [
            _c(
              "div",
              { staticClass: "daily exercise-container" },
              [
                _c(
                  "div",
                  { staticClass: "exercise-header" },
                  [
                    _c(
                      "heading",
                      { staticClass: "exercise-title", attrs: { level: "h3" } },
                      [
                        _vm._v(
                          "\n                  Small Exercise\n              "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("custom-button", {
                      attrs: {
                        text: "List view",
                        size: "button-medium",
                        type: "achromatic-light",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("exercise-cards", {
                  attrs: {
                    effortColor: "green",
                    effortType: "small",
                    titleBody: "SMALL EXERCISE",
                    titleFooter: "",
                    exercises: _vm.dailyExercisesToBeDone,
                    activeExerciseIndex: _vm.activeDailyExerciseIndex,
                    isFetchingData: _vm.isFetchingData,
                    emptyMessage: _vm.dailyExercisesEmptyMessage,
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "monthly exercise-container" },
              [
                _c(
                  "div",
                  { staticClass: "exercise-header" },
                  [
                    _c(
                      "heading",
                      { staticClass: "exercise-title", attrs: { level: "h3" } },
                      [
                        _vm._v(
                          "\n                  Medium Exercise\n              "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("custom-button", {
                      attrs: {
                        text: "List view",
                        size: "button-medium",
                        type: "achromatic-light",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("exercise-cards", {
                  attrs: {
                    effortColor: "orange",
                    effortType: "medium",
                    titleBody: "MEDIUM EXERCISE",
                    titleFooter: "",
                    exercises: _vm.monthlyExercisesToBeDone,
                    activeExerciseIndex: _vm.activeMonthlyExerciseIndex,
                    isFetchingData: _vm.isFetchingData,
                    emptyMessage: _vm.monthlyExercisesEmptyMessage,
                  },
                }),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "card" }, [
          _c(
            "div",
            { staticClass: "card-title" },
            [
              _c("heading", { attrs: { level: "h3" } }, [
                _vm._v(" Cyber Fitness Leaderboard "),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card-desc" },
            [
              _c(
                "paragraph",
                {
                  staticClass: "card-desc-title",
                  attrs: { type: "p", variation: "label" },
                },
                [
                  _vm._v(
                    "\n              Comparing you to your industry peers that are of a similar size\n              "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "leaderboard-chart-wrapper" }, [
                _c(
                  "div",
                  { staticClass: "leaderboard-chart-with-legends" },
                  [
                    Object.keys(_vm.leaderboardData).length > 0
                      ? _c(
                          "paragraph",
                          {
                            staticClass: "leaderboard-axis-y-title",
                            attrs: { type: "p", variation: "label" },
                          },
                          [
                            _vm._v(
                              "\n                          Hackability per 1000 services\n                      "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "leaderboard-chart" }),
                    _vm._v(" "),
                    Object.keys(_vm.leaderboardData).length > 0
                      ? _c(
                          "div",
                          { staticClass: "leaderboard-bottom-legends" },
                          [
                            _c(
                              "span",
                              [
                                _c(
                                  "paragraph",
                                  { attrs: { type: "p", variation: "label" } },
                                  [
                                    _c("i", {
                                      staticClass: "green-circle fas fa-circle",
                                    }),
                                    _vm._v(
                                      "\n                              Your Hackability Score\n                              "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-title" }, [
            _c(
              "div",
              { staticClass: "card-title-cyber-fitness-progress" },
              [
                _c("heading", { attrs: { level: "h3" } }, [
                  _vm._v(" Cyber Fitness Progress "),
                ]),
                _vm._v(" "),
                _c("img", {
                  attrs: {
                    src: "/assets/images/cyber-fitness-progress-config-icon.svg",
                    alt: "config-icon",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-desc" }, [
            _c("div", { staticClass: "progress-chart-wrapper" }, [
              _c("div", { staticClass: "progress-chart-wrapper" }, [
                _c(
                  "div",
                  { staticClass: "progress-chart-with-legends" },
                  [
                    Object.keys(_vm.progressData).length > 0
                      ? _c(
                          "paragraph",
                          {
                            staticClass: "progress-axis-y-title",
                            attrs: { type: "p", variation: "label" },
                          },
                          [
                            _vm._v(
                              "\n                          Hackability per 1000 services\n                      "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "progress-chart" }),
                    _vm._v(" "),
                    Object.keys(_vm.progressData).length > 0
                      ? _c("div", { staticClass: "progress-bottom-legends" }, [
                          _c(
                            "span",
                            [
                              _c(
                                "paragraph",
                                {
                                  staticClass: "grey-text",
                                  attrs: { type: "p", variation: "label" },
                                },
                                [
                                  _vm._v(
                                    "\n                                  Scan date\n                              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    Object.keys(_vm.progressData).length > 0
                      ? _c("div", { staticClass: "progress-bottom-legends" }, [
                          _c(
                            "span",
                            [
                              _c(
                                "paragraph",
                                { attrs: { type: "p", variation: "label" } },
                                [
                                  _c("i", {
                                    staticClass: "green-circle fas fa-circle",
                                  }),
                                  _vm._v(
                                    "\n                                      Your Current Score\n                              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            [
                              _c(
                                "paragraph",
                                { attrs: { type: "p", variation: "label" } },
                                [
                                  _c("i", {
                                    staticClass: "purple-circle fas fa-circle",
                                  }),
                                  _vm._v(
                                    "\n                                      " +
                                      _vm._s(_vm.targetProgressLegend) +
                                      "\n                              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }